import { useAppSelector, useToggle } from '~/hooks';
import { IJobReducerState } from '~/reducers/jobReducer/interfaces';
import { getIndustrialAverage, isWithinHoursLimit } from '~/utils/JobUtils';

interface IUseTipsPayload {
  date: Date;
  hourlyRate: string;
  profession: string;
  startsAt: string;
}

const DEFAULT_RATING = {
  average: 49,
  max: 100,
  min: 18,
};
const INDUSTRIAL_THRESHOLD = 105;
const HOURS_LIMIT = 36;

export const useTips = ({ date, hourlyRate, profession, startsAt }: IUseTipsPayload) => {
  const [isFlipped, controls] = useToggle();

  const averages = useAppSelector((state) => (state.job as IJobReducerState).averageRating) || {
    [profession]: DEFAULT_RATING,
  };
  const currentAverages = averages[profession] || DEFAULT_RATING;

  const isBelowIndustrialThreshold =
    getIndustrialAverage(currentAverages.average, hourlyRate) <= INDUSTRIAL_THRESHOLD;

  const shouldShowTips =
    isWithinHoursLimit(date, startsAt, HOURS_LIMIT) && isBelowIndustrialThreshold;

  return {
    isFlipped,
    shouldShowTips,
    toggle: controls.toggle,
  };
};
